import { ILoteRepository } from '../repositories/ILoteRepository'

export interface IValidateLoteQuarteirizado {
  execute(idLote: number): Promise<boolean>
}

export default class ValidateLoteQuarteirizadoImpl
  implements IValidateLoteQuarteirizado
{
  constructor(private readonly lotesRepository: ILoteRepository) {}

  public async execute(idLote: number): Promise<boolean> {
    const response = await this.lotesRepository.validateLoteQuarteirizado(
      idLote,
    )
    return response
  }
}
